import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-tooltip',
    imports: [],
    template: `
    <div class="bg-[#3F3F3F] text-white text-xs font-medium rounded py-2 px-2 shadow-md max-w-xs">
      {{ text }}
    </div>
  `
})
export class TooltipComponent {
  @Input({ required: true }) text: string = '';
}
